import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Styles from "./DatePicker.module.scss";
import dayjs from "dayjs";
const CommonDatePicker = ({ onChange, value, disabled, disableDate, disablePast, placeholder, clearable = true }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={["DatePicker"]} sx={{ padding: 0 }}>
        <DatePicker
          className={Styles.dateAdapter}
          disabled={disabled}
          disablePast={disablePast}
          format="DD/MM/YYYY"
          onChange={onChange}
          value={value ? dayjs(value) : null}
          shouldDisableDate={(date) =>
            disableDate
              ? date.isBefore(dayjs(), "day") || date.isSame(dayjs(), "day")
              : false
          }
          slotProps={{
            field: { clearable: clearable },
            textField: {
              placeholder: placeholder,
              size: "small",
            }
          }}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
};

export default CommonDatePicker;
